import { environment } from 'src/environments/environment';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class SharedAssociatedUserService {
    constructor(private http: HttpClient) {}

    addNewUser(subModuleId, id, userData){
        return this.http.post<any>( `${environment.appOrgUrl}User/${subModuleId}/${id}`, userData);
    }

    transferAndDelete(subModuleId, id, transferData){
        return this.http.post<any>( `${environment.appOrgUrl}User/${subModuleId}/${id}`, transferData);
    }

    getDiassociatedUsers(subModuleId, id){
        return this.http.get<any>(`${environment.appOrgUrl}User/DissociateList/${subModuleId}/${id}`);
    }

}